import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";

const TEXT = "Nous croyons qu'un bureau clair libère l'esprit, qu'une bougie allumée marque la fin du travail, et qu'un bon outil se fait oublier. Moins d'objets, mieux choisis.";

const Word = ({ w, range, progress }) => {
  const opacity = useTransform(progress, range, [0.28, 1]);
  return <motion.span style={{ opacity }} className="mr-[0.25em] inline-block">{w}</motion.span>;
};

export const Manifesto = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start 0.85", "end 0.45"] });
  const words = TEXT.split(" ");
  return (
    <section ref={ref} data-testid="manifesto-section" className="bg-[var(--ink)] px-5 py-28 sm:px-10 sm:py-40 text-[var(--bone)]">
      <div className="mx-auto max-w-[1200px]">
        <p className="font-mono-label mb-10 text-xs text-[#BDB5A8]">Manifeste</p>
        <p className="font-display text-3xl sm:text-5xl lg:text-6xl font-light leading-[1.12] tracking-tight">
          {words.map((w, i) => (
            <Word key={i} w={w} progress={scrollYProgress} range={[i / words.length, (i + 1) / words.length]} />
          ))}
        </p>
        <div className="mt-16 grid grid-cols-2 gap-8 border-t border-white/15 pt-10 sm:grid-cols-4">
          {[["11", "Univers"], ["54", "Sélections"], ["12", "Classements top ventes"], ["0 €", "Surcoût pour vous"]].map(([v, l]) => (
            <div key={l}>
              <p className="font-display text-4xl sm:text-5xl text-[var(--terra)]">{v}</p>
              <p className="mt-2 text-sm text-[#BDB5A8]">{l}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
